import { Model } from '@vuex-orm/core'
import RatePlanPrice from '@/models/RatePlanPrice'
import TotalPrice from '@/models/TotalPrice'

import Booking from '@/models/user/Booking'
import ConfigurationFee from "@/models/ConfigurationFee"

export default class Configuration extends Model {
  declare id: string
  declare identifier: number
  declare booking: Booking
  declare bookingId: string | number
  declare rateplanPrices: RatePlanPrice[]
  declare packagePrices: RatePlanPrice[]
  declare specialOfferPrices: RatePlanPrice[]
  declare fees: ConfigurationFee[]
  declare paymentPrice: number
  declare totalPrice: TotalPrice[]
  declare session: string

  static entity = 'configurations'
  static primaryKey = 'identifier'

  static fields() {
    return {
      id: this.attr(null),
      identifier: this.number(0),
      booking: this.belongsTo(Booking, 'bookingId'),
      bookingId: this.attr(1),
      rateplanPrices: this.hasMany(RatePlanPrice, 'configurationId'),
      packagePrices: this.hasMany(RatePlanPrice, 'configurationId'),
      specialOfferPrices: this.hasMany(RatePlanPrice, 'configurationId'),
      fees: this.hasMany(ConfigurationFee, 'configurationId'),
      paymentPrice: this.number(0),
      totalPrice: this.hasMany(TotalPrice, 'configurationId'),
      session: this.attr('')
    }
  }


  get totalBookingPriceAmount() {
    return this.totalPrice.reduce((acc, curr) => {
      return acc + curr.totalPrice
    }, 0)
  }
}
